import { StyleSheet } from '@react-pdf/renderer'

// TABLEFONTBOOST-2026-10-01 — every fontSize below bumped by exactly +2pt
// (client's ask, "como si fuera en Word, su equivalente" — 2pt = 2.6667px,
// applied uniformly via a script so every size scaled proportionally, not
// hand-rounded one at a time). Only OrderPDF.js/DownloadOrderPDF.js import
// this file (confirmed — no other page shares it), so this is scoped to the
// Sales Order PDF only, same reasoning as css/table-font-boost.css for the
// on-screen tables. To revert: subtract 2.6667 from each fontSize value.
const pdfConfig = StyleSheet.create({
HeaderStyle: {
        backgroundColor: "rgb(255, 255, 255)",
        color: "rgb(0, 0, 0)",
    },
    HeaderMargin: {
        top: "30px",
        height: "110px"
    },
    BusinessLogo: {
        width: "150px",
        left: "35px",
        top: "10px",

    },
    ContactInfo: {
        textAlign: "justify",
        fontSize: "14.7px",
        top: "-30px",
        left: "220px"
    },
    marginInfo: {
        width: "80%",
        marginLeft: "12%",
        display: "flex",
        flexDirection: "row",
        marginBottom: "2px",
        color: "rgb(255, 255, 255)"

    },
    OrderTitleStyle: {
        color: "rgb(0, 0, 0)",
        textAlign: "center",
        fontSize: "22.7px",
        marginTop: "0px",
        marginBottom: "15px"
    },
    OrderInformation: {
        width: "100%",
        backgroundColor: "rgb(255, 255, 255)",
    },
    TitleStyle: {
        textAlign: "left",
        fontSize: "12.7px",
        width: "50%",
        color: "rgb(0, 0, 0)",
    },

    TextSeparator: {
        marginBottom: "4px"
    },
    InfoEncabezadoStyle: {
        width: "30%",
        fontSize: "14.7px",
    },
    TextSeparator2: {
        marginTop: "1px",
        marginBottom: "3.5px"
    },

    Table: {
        width: "92%",
        marginLeft: "4%",
        marginTop: "9px"

    },

    CabeceraTabla: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        borderBottom: '1px',
        borderColor: 'black',
        borderStyle: 'dotted',
    },
    CuerpoTabla: {
        width: "100%",
        textAlign: "center",
        fontSize: "10.7px",
        borderBottom: '1px',
        borderColor: 'black',
        borderStyle: 'dotted',

    },
    Fila: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
    },
    FilaBreak: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        paddingTop: "2px"
    },
    ColumnaPie: {

        textAlign: "center",
        fontSize: "12.7px",
    },
    ColumnaTextoNormal: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo: {
        width: "25%",

        fontSize: "10.7px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargoCenter: {
        width: "20%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaCantidades: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormalTitulo: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block"
    },
    ColumnaTextoLargoTitulo: {
        width: "25%",

        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo4Titulo: {
        width: "70%",

        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoCenterTitulo: {
        width: "20%",

        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },

    ColumnaCantidadesTitulo: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo2: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo2Titulo: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo3: {
        width: "50%",
        fontSize: "10.7px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo4: {
        width: "70%",
        fontSize: "10.7px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo3Titulo: {
        width: "50%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2Titulo: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },

    CommentStyle: {
        marginTop: '15px',
        fontSize: "10.7px",
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "justify",
        borderBottom: '1px',
        borderRight: '1px',
        borderLeft: '1px',
        borderTop: '1px',
        borderColor: 'black',
        borderStyle: 'solid',
    },
    ColumnaHeader: {
        width: "35%",
        fontSize: "13.7px",
        textAlign: "left",
        display: "block",
        color: "#000000"
    },
    ColumnaHeader2: {
        width: "15%",
        fontSize: "13.7px",
        textAlign: "left",
        display: "block",
        color: "#000000",

    },
    ColumnaTextoNormalLeft: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "left",
        display: "block",

    },
    ColumnaPrecios: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    ColumnaPreciosTitulo: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormalLeftTitulo: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormalBottom: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoBottom: {
        width: "25%",

        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoCenterBottom: {
        width: "20%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },

    ColumnaCantidadesBottom: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo2Bottom: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo3Bottom: {
        width: "50%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo4Bottom: {
        width: "70%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2Bottom: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    ColumnaPreciosBottom: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    ColumnaTextoNormalLeftBottom: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormal2Left: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoNormal2LeftTitulo: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormal2LeftBottom: {
        fontSize: "10.7px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    DolarTitulo: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    Dolar: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    DolarBottom: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    }
});

export default pdfConfig;